import * as swcHelpers from '@swc/helpers';
import { unwrapResponse } from '../response.js';
import { acceptJson } from '../shared.js';

var PaymentState;
(function(PaymentState) {
    PaymentState["Paid"] = "Paid";
    PaymentState["Pending"] = "Pending";
    PaymentState["Failed"] = "Failed";
    PaymentState["CreditOwed"] = "CreditOwed";
    PaymentState["BalanceDue"] = "BalanceDue";
})(PaymentState || (PaymentState = {}));
const getPaymentState = function() {
    var _ref = swcHelpers.asyncToGenerator(function*(apiUrl, request) {
        return unwrapResponse((yield fetch(`${apiUrl}/order/${request.orderId}/payment-state`, {
            method: 'GET',
            headers: swcHelpers.objectSpread({}, acceptJson)
        })));
    });
    return function getPaymentState(apiUrl, request) {
        return _ref.apply(this, arguments);
    };
}();

export { PaymentState, getPaymentState };
//# sourceMappingURL=get-payment-state.js.map
